import { initTopAssets } from '../components/top-assets.js';

import '../../src/assets/scss/sections/_top-assets.scss';


document.addEventListener('DOMContentLoaded', function () {
    initTopAssets();
});
